export const BellIcon = () => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 7.4C16 5.70261 15.3679 4.07475 14.2426 2.87452C13.1174 1.67428 11.5913 1 10 1C8.4087 1 6.88258 1.67428 5.75736 2.87452C4.63214 4.07475 4 5.70261 4 7.4C4 14.8667 1 17 1 17H19C19 17 16 14.8667 16 7.4Z"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.73 20C11.5542 20.3031 11.3019 20.5547 10.9982 20.7295C10.6946 20.9044 10.3504 20.9965 9.99999 20.9965C9.64959 20.9965 9.30539 20.9044 9.00179 20.7295C8.69819 20.5547 8.44579 20.3031 8.26999 20"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
